export interface FilaDescricaoItemJson {
  name?: string;
  borda?: string | null;
  sabores?: unknown[];
  quantidade?: number;
}

function formatarDescricaoItem(item: FilaDescricaoItemJson): string {
  const tamanho = (item.name || "Pizza").replace(/^Pizza\s+/i, "").trim();

  const bordaRaw = item.borda?.trim();
  const bordaStr =
    bordaRaw && bordaRaw.toLowerCase() !== "sem borda" ? bordaRaw : "Sem borda";

  let saboresStr = "";
  if (item.sabores && Array.isArray(item.sabores) && item.sabores.length > 0) {
    const total = item.sabores.length;
    const nomes = item.sabores.map((s) =>
      typeof s === "string" ? s : String((s as { name?: string }).name ?? "")
    );
    const porSabor = new Map<string, number>();
    for (const nome of nomes) {
      if (nome) porSabor.set(nome, (porSabor.get(nome) || 0) + 1);
    }
    saboresStr = Array.from(porSabor.entries())
      .map(([nome, count]) => (total > 1 ? `${count}/${total} ${nome}` : nome))
      .filter(Boolean)
      .join(", ");
  }

  return [tamanho, bordaStr, saboresStr || "—"].join("\n");
}

export function filaDescricaoJsonParaTexto(desc: unknown): string {
  if (!desc || !Array.isArray(desc) || desc.length === 0) return "";
  return desc
    .map((entry) => formatarDescricaoItem(entry as FilaDescricaoItemJson))
    .filter(Boolean)
    .join("\n\n");
}

export function formatPainelDescricaoResumo(
  descricao: string | null | undefined
): string {
  const raw = descricao?.trim();
  if (!raw) return "—";

  if (raw.includes("\n")) {
    const linhas = raw
      .split("\n")
      .map((l) => l.trim())
      .filter(Boolean);
    return linhas.join(" · ") || "—";
  }

  const [size, ...rest] = raw.split(" - ");
  if (rest.length === 0) return raw;
  return [size?.trim(), rest.join(" - ").trim()].filter(Boolean).join(" · ");
}
